export const LOGIN_PAGE = 0;
export const MAIN_PAGE = 1;

export const MOVE_TO_LOGIN_PAGE = "MOVE_TO_LOGIN";
export const moveToLoginPage = () => ({
  type: MOVE_TO_LOGIN_PAGE,
});

export const MOVE_TO_MAIN_PAGE = "MOVE_TO_MAIN";
export const moveToMainPage = () => ({
  type: MOVE_TO_MAIN_PAGE
});